import { ApiFactory, type ApiDataResponse } from '@/utils/api';
import type { CalendarData, TagsRequest } from '@/models/interface/calendar';

export class MemberRecordService extends ApiFactory {
  constructor() {
    super('MemberRecord');
  }

  /**
   * 查詢行事曆各種事項
   * @param params
   * @returns
   */
  queryCalendar(params: {
    startTimestamp: number;
    endTimestamp: number;
  }): Promise<ApiDataResponse<CalendarData[]>> {
    const serializedParams = new URLSearchParams({
      startTimestamp: params.startTimestamp.toString(),
      endTimestamp: params.endTimestamp.toString()
    });

    return this.get(`QueryCalendar?${serializedParams}`);
  }

  /**
   * 修改Tag狀態
   * @param data
   * @returns
   */
  updateCalendarTags(data: TagsRequest): Promise<ApiDataResponse<boolean>> {
    return this.post(`UpdateCalendarTags`, data);
  }

  /**
   * 取得已使用點數及總點數
   * @returns
   */
  getTotalAndUsed(): Promise<
    ApiDataResponse<{
      total: number;
      used: number;
    }>
  > {
    return this.get(`GetTotalAndUsed`);
  }
}
